import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './AuthGuard'

/* Auth */
const Login = () => import('@/views/Auth/Login')
const Signup = () => import('@/views/Auth/Signup')
const ChangePassword = () => import('@/views/Auth/ChangePassword')
const ForgotPassword = () => import('@/views/Auth/ForgotPassword')
const Verified = () => import('@/views/Auth/Verified')
const VerificationSms = () => import('@/views/Auth/VerificationSms')
const Resend = () => import('@/views/Auth/ResendSms')
const SiteSelection = () => import('@/views/Auth/SiteSelection')

const Index = () => import('@/views/Landing/Index')

/* Static page */
const NotFound = () => import('@/views/StaticPage/NotFound')
const Forbidden = () => import('@/views/StaticPage/Forbidden')
const TermsAndCondition = () => import('@/views/TermsAndCondition/TermsAndCondition')

const Tracking = () => import('@/views/Tracking/Tracking')
const TrackingHistory = () => import('@/views/Tracking/TrackingHistory')

/* User layout */
const UserLayout = () => import('@/views/User/Layout/Layout')

/* Order */
const Order = () => import('@/views/User/Order/Order')
const OrderCreateStep1 = () => import('@/views/User/Order/OrderCreateStep1')
const OrderMyShipmentCreateStep1 = () => import('@/views/User/Order/OrderMyShipmentCreateStep1')
const OrderMyShipmentCreateStep2 = () => import('@/views/User/Order/OrderMyShipmentCreateStep2')
const OrderMyShipmentCreateStep3 = () => import('@/views/User/Order/OrderMyShipmentCreateStep3')
const OrderMyShipmentCreateStep4 = () => import('@/views/User/Order/OrderMyShipmentCreateStep4')
const OrderCreateStep2 = () => import('@/views/User/Order/OrderCreateStep2')
const Byu4you = () => import('@/views/User/Order/Byu4you')
const OrderView = () => import('@/views/User/Order/OrderView')
const OrderEdit = () => import('@/views/User/Order/OrderEdit')
const CombineOrders = () => import('@/views/User/Order/CombineOrders')
const GroupsList = () => import('@/views/User/Order/GroupsList')
const GroupOrders = () => import('@/views/User/Order/GroupOrders')

const SplitOrders = () => import('@/views/User/Order/SplitOrders')
const SplitOrderSecondStep = () => import('@/views/User/Order/SplitOrderSecondStep')
const SplitOrderThirdStep = () => import('@/views/User/Order/SplitOrderThirdStep')

/* Invoices */
const Invoice = () => import('@/views/User/Invoices/Invoice')

/* Department */
const DepartmentView = () => import('@/views/User/Department/DepartmentView')

/* Tracking for auth users */
const UserTracking = () => import('@/views/User/Tracking/Tracking')
const UserTrackingView = () => import('@/views/User/Tracking/TrackingHistory')

/* Profile */
const Profile = () => import('@/views/User/Profile/Profile')
const AddressBookEdit = () => import('@/views/User/Profile/AddressBookEdit')

/* FAQ */
const FAQ = () => import('@/views/User/FAQ/FAQ')

/* SelfServes */
const SSLayout = () => import('@/views/SelfServes/Layout/Layout');
const SSHome = () => import('@/views/SelfServes/SSHome');
const SSShipper = () => import('@/views/SelfServes/SSShipper');
const SSDelivery = () => import('@/views/SelfServes/SSDelivery');
const SSMerchandises = () => import('@/views/SelfServes/SSMerchandises');
const SSAddMerchandise = () => import('@/views/SelfServes/SSAddMerchandise');

/* Admin */
const AdminLayout = () => import('@/views/Admin/Layout/Layout');
const AdminLayoutPrint = () => import('@/views/Admin/Layout/LayoutPrint');
const AdminDashboard = () => import('@/views/Admin/Dashboard');
const AdminPrint = () => import('@/views/Admin/Print');
const AdminOrders = () => import('@/views/Admin/Orders/Orders');
const AdminViewOrder = () => import('@/views/Admin/Orders/View');
const AdminEditOrder = () => import('@/views/Admin/Orders/AddOrEdit');
const AdminAddOrder = () => import('@/views/Admin/Orders/AddOrEdit');
const AdminUsers = () => import('@/views/Admin/Users/Users');
const AdminAddOrEditUser = () => import('@/views/Admin/Users/AddOrEdit.vue');
const AdminAddresses = () => import('@/views/Admin/Addresses/Addresses');
const AdminAddOrEditAddresses = () => import('@/views/Admin/Addresses/AddOrEdit.vue');
const AdminReportsPendingOrders = () => import('@/views/Admin/Reports/PendingOrders.vue');
const AdminReportsNotArrivedOrders = () => import('@/views/Admin/Reports/NotArrivedOrders.vue');
const AdminReportsSelfServe = () => import('@/views/Admin/Reports/SelfServe/SelfServe.vue');
const AdminReportsDelivery = () => import('@/views/Admin/Reports/Delivery/Delivery.vue');
const AdminReportsWalkin = () => import('@/views/Admin/Reports/Walkin/Walkin.vue');
const AdminReportsShelfHistory = () => import('@/views/Admin/Reports/ShelfHistory/ShelfHistory.vue');
const AdminReportsSummary = () => import('@/views/Admin/Reports/Summary/Summary.vue');
const AdminReportsFlights = () => import('@/views/Admin/Reports/Flights/Flights.vue');
const AdminReportsAddOrEditFlights = () => import('@/views/Admin/Reports/Flights/AddOrEdit.vue');
const AdminReportsFlightsConsolidatedInvoice = () => import('@/views/Admin/Reports/Flights/ConsolidatedInvoice.vue');
const AdminReportsFlightsManageBags = () => import('@/views/Admin/Reports/Flights/ManageBags.vue');
const AdminReportsFlightsManageBagsAddBags = () => import('@/views/Admin/Reports/Flights/ManageBagsAddBags.vue');
const AdminReportsFlightsBagsList = () => import('@/views/Admin/Reports/Flights/BagsList.vue');
const AdminReportsFlightsProfitLoss = () => import('@/views/Admin/Reports/Flights/ProfitLoss.vue');
const AdminReportsFlightsPackingList = () => import('@/views/Admin/Reports/Flights/PackingList.vue');

const AdminReportsBags = () => import('@/views/Admin/Reports/Bags/Bags.vue');
const AdminReportsBagViewAndPay = () => import('@/views/Admin/Reports/Bags/BagViewAndPay.vue');
const AdminReportsBagAddOrderInBag = () => import('@/views/Admin/Reports/Bags/BagAddOrderInBag.vue');
const AdminReportsAddOrEditBags = () => import('@/views/Admin/Reports/Bags/AddOrEdit.vue');

const AdminSettingsMessengerTranslations = () => import('@/views/Admin/Settings/MessengerTranslations.vue');
const AdminSettingsDeliveryOptions = () => import('@/views/Admin/Settings/DeliveryOptions.vue');
const AdminSettingsGeneral = () => import('@/views/Admin/Settings/General.vue');
const AdminSettingsEmailTemplates = () => import('@/views/Admin/Settings/EmailTemplates/EmailTemplates.vue');
const AdminSettingsEmailTemplatesAddOrEdit = () => import('@/views/Admin/Settings/EmailTemplates/AddOrEdit.vue');
const AdminSettingsTranslations = () => import('@/views/Admin/Settings/Translations/Translations.vue');
const AdminSettingsTranslationsEdit = () => import('@/views/Admin/Settings/Translations/Edit.vue');
const AdminSettingsTermsAndConditionsEdit = () => import('@/views/Admin/Settings/TermsAndConditions/Edit.vue');
const AdminSettingsManageAnnouncementEdit = () => import('@/views/Admin/Settings/ManageAnnouncement/Edit.vue');
const AdminSettingsInvoicesTextEdit = () => import('@/views/Admin/Settings/InvoicesText/Edit.vue');
const AdminSettingsSelfServeQrGenerate = () => import('@/views/Admin/Settings/SelfServeQr/GetQR.vue');
const AdminSettingsDepartments = () => import('@/views/Admin/Settings/Departments/Departments.vue');
const AdminSettingsDepartmentsAddOrEdit = () => import('@/views/Admin/Settings/Departments/AddOrEdit.vue');
const AdminSettingsDepartmentsRates = () => import('@/views/Admin/Settings/DepartmentsRates/DepartmentsRates.vue');
const AdminSettingsDepartmentsRatesAddOrEdit = () => import('@/views/Admin/Settings/DepartmentsRates/AddOrEdit.vue');
const AdminSettingsPaymentMethods = () => import('@/views/Admin/Settings/PaymentMethods/PaymentMethods.vue');
const AdminSettingsPaymentMethodsAddOrEdit = () => import('@/views/Admin/Settings/PaymentMethods/AddOrEdit.vue');
const AdminSettingsWebSiteAddresses = () => import('@/views/Admin/Settings/WebSiteAddresses/WebSiteAddresses.vue');
const AdminSettingsWebSiteAddressesAddOrEdit = () => import('@/views/Admin/Settings/WebSiteAddresses/AddOrEdit.vue');
const AdminSettingsDuties = () => import('@/views/Admin/Settings/Duties/Duties.vue');
const AdminSettingsDutiesAddOrEdit = () => import('@/views/Admin/Settings/Duties/AddOrEdit.vue');
const AdminSettingsManageDeliveryPricesEdit = () => import('@/views/Admin/Settings/ManageDeliveryPrices/Edit.vue');
const AdminSettingsCustomCharges = () => import('@/views/Admin/Settings/CustomCharges/CustomCharges.vue');
const AdminSettingsCustomChargesAddOrEdit = () => import('@/views/Admin/Settings/CustomCharges/AddOrEdit.vue');
const AdminAttachmentsOrder = () => import('@/views/Admin/Orders/Attachments.vue');
const AdminRequestReturn = () => import('@/views/Admin/Orders/RequestReturn.vue');
const AdminCombinedOrders = () => import('@/views/Admin/Orders/Combine/CombinedOrders.vue');
const AdminEditGroup = () => import('@/views/Admin/Orders/Combine/EditGroup.vue');
const AdminViewGroup = () => import('@/views/Admin/Orders/Combine/ViewGroup.vue');
const AdminCreateGroup = () => import('@/views/Admin/Orders/Combine/CreateGroup.vue');
const AdminSplitOrder = () => import('@/views/Admin/Orders/SplitOrder.vue');
const AdminInvoices = () => import('@/views/Admin/Invoices/Invoices.vue');
const AdminViewInvoice = () => import('@/views/Admin/Invoices/View.vue');
const AdminAddOrEditInvoice = () => import('@/views/Admin/Invoices/AddOrEdit.vue');
const AdminSettingsExchangeRates = () => import('@/views/Admin/Settings/ExchangeRates/ExchangeRates.vue');

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}

    if (to.hash && (typeof to.hash === 'string' || typeof to.hash === 'number')) {
      position.selector = to.hash

      // specify offset of the element
      if (to.hash === '#how-does-it-work') {
        position.offset = {y: 60}
      }

      if (to.hash && document.querySelector && document.querySelector(to.hash)) {
        return position
      }
      return false
    }

    return new Promise(() => {
      if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
      }
    })
  }
}

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {scrollToTop: true},
    },
    {
      path: '/self-serves',
      component: SSLayout,
      children: [
        {
          path: '/self-serves/process/shipper',
          name: 'SSShipper',
          component: SSShipper,
          meta: {
            ssRequiresAuth: true
          },
          props: true,
        },
        {
          path: '/self-serves/:hash',
          name: 'SSHomeHash',
          component: SSHome,
          meta: {
            ssRequiresAuth: false
          },
          props: true,
        },
        {
          path: '/self-serves',
          name: 'SSHome',
          component: SSHome,
          meta: {
            ssRequiresAuth: false
          },
          props: true,
        },
        {
          path: '/self-serves/process/delivery',
          name: 'SSDelivery',
          component: SSDelivery,
          meta: {
            ssRequiresAuth: true
          },
          props: true,
        },
        {
          path: '/self-serves/process/merchandises',
          name: 'SSMerchandises',
          component: SSMerchandises,
          meta: {
            ssRequiresAuth: true
          },
          props: true,
        },
        {
          path: '/self-serves/process/add-merchandise/:id',
          name: 'SSAddMerchandise',
          component: SSAddMerchandise,
          meta: {
            ssRequiresAuth: false
          },
          props: true,
        },
      ],
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        requiresNotAuth: true // After authorization will be not available
      },
    },
    {
      path: '/verification-sms',
      name: 'VerificationSms',
      component: VerificationSms,
      meta: {scrollToTop: true}
    },
    {
      path: '/resend',
      name: 'Resend',
      component: Resend,
      meta: {scrollToTop: true}
    },
    {
      path: '/verified/:code',
      props: true,
      name: 'Verified',
      component: Verified,
      meta: {
        requiresNotAuth: true
      },
    },
    {
      path: '/invoice-pay/:id/:email',
      props: true,
      name: 'InvoicePayWithoutAuth',
      component: () => import('@/views/InvoicePay'),
      meta: {
        requiresNotAuth: false
      },
    },
    {
      path: '/change-password/:token',
      props: true,
      name: 'ChangePassword',
      component: ChangePassword,
      meta: {
        requiresNotAuth: true
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresNotAuth: true
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresNotAuth: true
      },
    },

    /* Order */
    {
      path: '/orders',
      component: UserLayout,
      children: [
        /* Add new orders | Step 1 */
        {
          path: 'add/:step(1)',
          children: [
            {
              path: 'online',
            },
            {
              path: 'shipment',
            },
          ],
          component: OrderCreateStep1,
          name: 'OrderCreateStep1'
        },
        {
          path: 'add/:step(1)',
          children: [
            {
              path: 'my-shipment-label',
            },
            {
              path: 'my-shipment-drop-off',
            },
          ],
          component: OrderMyShipmentCreateStep1,
          name: 'OrderMyShipmentCreateStep1'
        },
        /* Add new orders | Step 2 */
        {
          path: 'add/:step(2)',
          children: [
            {
              path: 'online',
            },
            {
              path: 'shipment',
            },
          ],
          component: OrderCreateStep2,
          name: 'OrderCreateStep2'
        },
        {
          path: 'add/:step(2)',
          children: [
            {
              path: 'my-shipment-label',
            },
            {
              path: 'my-shipment-drop-off',
            },
          ],
          component: OrderMyShipmentCreateStep2,
          name: 'OrderMyShipmentCreateStep2'
        },
        {
          path: 'add/:step(3)',
          children: [
            {
              path: 'my-shipment-label',
            },
            {
              path: 'my-shipment-drop-off',
            },
          ],
          component: OrderMyShipmentCreateStep3,
          name: 'OrderMyShipmentCreateStep3'
        },
        {
          path: 'add/:step(4)',
          children: [
            {
              path: 'my-shipment-label',
            },
            {
              path: 'my-shipment-drop-off',
            },
          ],
          component: OrderMyShipmentCreateStep4,
          name: 'OrderMyShipmentCreateStep4'
        },
        /* Byu4you */
        {
          path: 'byu4you',
          component: Byu4you,
          name: 'Byu4you'
        },
        /* Combine Orders */
        {
          path: 'combine-orders/:page(\\d+)/:order(\\d+)?',
          props: true,
          component: CombineOrders,
          name: 'CombineOrders',
        },
        {
          path: 'combine-orders/group/:id(\\d+)+',
          props: true,
          component: GroupOrders,
          name: 'GroupOrders',
        },
        {
          path: 'combine-orders/groups/:page(\\d+)*',
          props: true,
          component: GroupsList,
          name: 'GroupsList',
        },
        /* Split orders */
        {
          path: 'split',
          component: SplitOrders,
          name: 'SplitOrders',
          children: [
            /* Add new orders | Step 1 */
            {
              path: ':step(1)/:page(\\d+)',
              props: true,
              component: SplitOrders,
              name: 'SplitOrderFirstStep'
            },
            /* Add new orders | Step 2 */

            // {
            //   path: ':step(3)',
            //
            //   component: OrderCreateStep2,
            //   name: 'OrderCreateStep2'
            // },
          ]
        },

        {
          path: ':id/split/:step(2)',
          component: SplitOrderSecondStep,
          name: 'SplitOrderSecondStep',
        },
        {
          path: ':id/split/:step(3)',
          component: SplitOrderThirdStep,
          name: 'SplitOrderThirdStep',
        },
        /* Edit order by id */
        {
          path: 'edit/:id',
          props: true,
          component: OrderEdit,
          name: 'OrderEdit'
        },
        /* View order by id */
        {
          path: 'view/:id',
          props: true,
          component: OrderView,
          name: 'OrderView'
        },
        /* Index page */

        {
          path: ':tab(/completed|inProgress/)/:page(\\d+)?*',
          component: Order,
          name: 'OrderTab'
        },
        {
          path: ':page(\\d+)?*',
          component: Order,
          name: 'OrderPage'
        },

        // {
        //   path: '/?*',
        //   component: Order,
        //   name: 'Order'
        // },
        {
          path: '',
          component: Order,
          name: 'Order'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Invoices */
    {
      path: '/invoices',
      component: UserLayout,
      children: [
        /* View invoice */
        {
          path: 'pay/:id',
          props: true,
          component: () => import('@/views/User/Invoices/InvoicePay'),
          name: 'InvoicePay'
        },

        /* Index page */
        {
          path: ':tab(/completed|inProgress/)/:page(\\d+)?*',
          component: Invoice,
          name: 'InvoiceTab'
        },
        {
          path: ':page(\\d+)?*',
          component: Invoice,
          name: 'InvoicePage'
        },
        {
          path: '',
          component: Invoice,
          name: 'Invoice'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Department */
    {
      path: '/departments',
      component: UserLayout,
      children: [
        /* Index page */
        {
          path: '/',
          component: DepartmentView,
          name: 'DepartmentView'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Tracking */
    {
      path: '/user-tracking',
      component: UserLayout,
      children: [
        /* View invoice */
        {
          path: ':tracking',
          props: true,
          component: UserTrackingView,
          name: 'UserTrackingView'
        },
        /* Index page */
        {
          path: '/',
          component: UserTracking,
          name: 'UserTracking'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Profile */
    {
      path: '/profile',
      component: UserLayout,
      children: [
        {
          path: '/',
          component: Profile,
          name: 'Profile',
        },
        /* Index page */
        {
          path: ':tab',
          component: Profile,
          name: 'ProfileTab',
          props: true,
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Address-book */
    {
      path: '/address-book',
      component: UserLayout,
      children: [
        /* Edit page */
        {
          path: 'edit/:id',
          props: true,
          component: AddressBookEdit,
          name: 'AddressBookEdit'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Profile */
    {
      path: '/faq',
      component: UserLayout,
      children: [
        /* Index page */
        {
          path: '/',
          component: FAQ,
          name: 'FAQ'
        },
      ],
      meta: {
        requiresAuth: true // Without authorization is not available
      },
    },

    /* Tracking */
    {
      path: '/tracking',
      name: 'Tracking',
      component: Tracking,
      meta: {scrollToTop: true}
    },
    {
      path: '/tracking-history/:tracking',
      props: true,
      name: 'TrackingHistory',
      component: TrackingHistory,
      meta: {scrollToTop: true}
    },

    /* Static page */
    {
      path: '/terms-and-conditions',
      name: 'TermsAndCondition',
      component: TermsAndCondition,
      meta: {scrollToTop: true}
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: {scrollToTop: true}
    },
    {
      path: '*',
      redirect: '/404',
      meta: {scrollToTop: true}
    },
    {
      path: '/403',
      name: 'Forbidden',
      component: Forbidden,
      meta: {scrollToTop: true}
    },
    {
      path: '*',
      redirect: '/403',
      meta: {scrollToTop: true}
    },

    /* Admin */
    {
      path: '/admin/site-selection',
      name: 'SiteSelection',
      component: SiteSelection,
      meta: {
        scrollToTop: true,
        requiresAuth: true,
        isAdmin: true,
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: AdminLayout,
      children: [
        {
          path: 'dashboard',
          props: true,
          component: AdminDashboard,
          name: 'AdminDashboard',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
      ],
    },
    {
      path: '/admin',
      name: 'AdminPrint',
      component: AdminLayoutPrint,
      children: [
        {
          path: 'print',
          props: true,
          component: AdminPrint,
          name: 'AdminPrint',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
      ],
    },
    {
      path: '/admin/orders',
      component: AdminLayout,
      children: [
        {
          path: '/',
          props: true,
          component: AdminOrders,
          name: 'AdminOrders',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'view/:id',
          props: true,
          component: AdminViewOrder,
          name: 'AdminViewOrder'
        },
        {
          path: 'add',
          props: true,
          component: AdminAddOrder,
          name: 'AdminAddOrder'
        },
        {
          path: 'edit/:id',
          props: true,
          component: AdminEditOrder,
          name: 'AdminEditOrder'
        },
        {
          path: 'attachments/:id',
          props: true,
          component: AdminAttachmentsOrder,
          name: 'AdminAttachmentsOrder'
        },
        {
          path: 'request-return/:id',
          props: true,
          component: AdminRequestReturn,
          name: 'AdminRequestReturn'
        },
        {
          path: 'groups',
          props: true,
          component: AdminCombinedOrders,
          name: 'AdminGroupOrders'
        },
        {
          path: 'groups/edit/:id',
          props: true,
          component: AdminEditGroup,
          name: 'AdminEditGroupOrder'
        },
        {
          path: 'groups/view/:id',
          props: true,
          component: AdminViewGroup,
          name: 'AdminViewGroupOrder'
        },
        {
          path: 'groups/add/:ids',
          props: true,
          component: AdminCreateGroup,
          name: 'AdminCreateGroupOrder'
        },
        {
          path: 'split/:id',
          props: true,
          component: AdminSplitOrder,
          name: 'AdminSplitOrder'
        },
      ],
    },
    {
      path: '/admin/groups',
      component: AdminLayout,
      children: [
        {
          path: '/',
          props: true,
          component: AdminCombinedOrders,
          name: 'AdminCombinedOrders'
        },
        {
          path: 'edit/:id',
          props: true,
          component: AdminEditGroup,
          name: 'AdminEditGroup'
        },
        {
          path: 'view/:id',
          props: true,
          component: AdminViewGroup,
          name: 'AdminViewGroup'
        },
        {
          path: 'add/:ids',
          props: true,
          component: AdminCreateGroup,
          name: 'AdminCreateGroup'
        },
      ],
    },
    {
      path: '/admin/invoices',
      component: AdminLayout,
      children: [
        {
          path: '/',
          props: true,
          component: AdminInvoices,
          name: 'AdminInvoices',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'view/:id',
          props: true,
          component: AdminViewInvoice,
          name: 'AdminViewInvoice',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'add/:orderId',
          props: true,
          component: AdminAddOrEditInvoice,
          name: 'AdminAddInvoice',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'edit/:id',
          props: true,
          component: AdminAddOrEditInvoice,
          name: 'AdminEditInvoice',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
      ],
    },
    {
      path: '/admin/users',
      component: AdminLayout,
      children: [
        {
          path: '/',
          props: true,
          component: AdminUsers,
          name: 'AdminUsers',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'add',
          props: true,
          component: AdminAddOrEditUser,
          name: 'AdminAddUser',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'edit/:id',
          props: true,
          component: AdminAddOrEditUser,
          name: 'AdminEditUser',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: ':id/addresses',
          props: true,
          component: AdminAddresses,
          name: 'AdminAddresses',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: ':id/addresses/add',
          props: true,
          component: AdminAddOrEditAddresses,
          name: 'AdminAddAddress',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: ':id/addresses/edit/:addressId',
          props: true,
          component: AdminAddOrEditAddresses,
          name: 'AdminEditAddress',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
      ],
    },
    {
      path: '/admin/reports',
      name: 'Reports',
      component: AdminLayout,
      children: [
        {
          path: 'pending-orders',
          props: true,
          component: AdminReportsPendingOrders,
          name: 'PendingOrders',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'not-arrived-orders',
          props: true,
          component: AdminReportsNotArrivedOrders,
          name: 'NotArrivedOrders',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'self-serve',
          props: true,
          component: AdminReportsSelfServe,
          name: 'AdminReportsSelfServe',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'delivery',
          props: true,
          component: AdminReportsDelivery,
          name: 'AdminReportsDelivery',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'walkin',
          props: true,
          component: AdminReportsWalkin,
          name: 'AdminReportsWalkin',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'shelves-history',
          props: true,
          component: AdminReportsShelfHistory,
          name: 'AdminReportsShelfHistory',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'summary',
          props: true,
          component: AdminReportsSummary,
          name: 'AdminReportsSummary',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'flights',
          props: true,
          component: AdminReportsFlights,
          name: 'AdminReportsFlights',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'flights/add',
          props: true,
          component: AdminReportsAddOrEditFlights,
          name: 'AdminReportsAddFlight',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/edit/:id',
          props: true,
          component: AdminReportsAddOrEditFlights,
          name: 'AdminReportsEditFlight',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/consolidated-invoice/:id',
          props: true,
          component: AdminReportsFlightsConsolidatedInvoice,
          name: 'AdminReportsFlightsConsolidatedInvoice',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/manage-bags/:id',
          props: true,
          component: AdminReportsFlightsManageBags,
          name: 'AdminReportsFlightsManageBags',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/add-bags/:id',
          props: true,
          component: AdminReportsFlightsManageBagsAddBags,
          name: 'AdminReportsFlightsManageBagsAddBags',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/bags-list/:id',
          props: true,
          component: AdminReportsFlightsBagsList,
          name: 'AdminReportsFlightsBagsList',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/profit-loss/:id',
          props: true,
          component: AdminReportsFlightsProfitLoss,
          name: 'AdminReportsFlightsProfitLoss',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'flights/packing-list/:id',
          props: true,
          component: AdminReportsFlightsPackingList,
          name: 'AdminReportsFlightsPackingList',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'bags',
          props: true,
          component: AdminReportsBags,
          name: 'AdminReportsBags',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'bags/add',
          props: true,
          component: AdminReportsAddOrEditBags,
          name: 'AdminReportsAddBag',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'bags/edit/:id',
          props: true,
          component: AdminReportsAddOrEditBags,
          name: 'AdminReportsEditBag',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'bags/view/:id',
          props: true,
          component: AdminReportsBagViewAndPay,
          name: 'AdminReportsBagViewAndPay',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'bags/add-orders/:id',
          props: true,
          component: AdminReportsBagAddOrderInBag,
          name: 'AdminReportsBagAddOrderInBag',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
      ],
    },
    {
      path: '/admin/settings',
      name: 'Settings',
      component: AdminLayout,
      children: [
        {
          path: 'general',
          props: true,
          component: AdminSettingsGeneral,
          name: 'AdminSettingsGeneral',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'email-templates',
          props: true,
          component: AdminSettingsEmailTemplates,
          name: 'AdminSettingsEmailTemplates',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'email-templates/:id',
          props: true,
          component: AdminSettingsEmailTemplatesAddOrEdit,
          name: 'AdminSettingsEmailTemplatesEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'translations',
          props: true,
          component: AdminSettingsTranslations,
          name: 'AdminSettingsTranslations',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'translations/:id',
          props: true,
          component: AdminSettingsTranslationsEdit,
          name: 'AdminSettingsTranslationsEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'terms-and-conditions',
          props: true,
          component: AdminSettingsTermsAndConditionsEdit,
          name: 'AdminSettingsTermsAndConditionsEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'manage-announcement',
          props: true,
          component: AdminSettingsManageAnnouncementEdit,
          name: 'AdminSettingsManageAnnouncementEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'manage-invoice-text',
          props: true,
          component: AdminSettingsInvoicesTextEdit,
          name: 'AdminSettingsInvoicesTextEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'self-serve-qr',
          props: true,
          component: AdminSettingsSelfServeQrGenerate,
          name: 'AdminSettingsSelfServeQrGenerate',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'departments',
          props: true,
          component: AdminSettingsDepartments,
          name: 'AdminSettingsDepartments',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'departments/add',
          props: true,
          component: AdminSettingsDepartmentsAddOrEdit,
          name: 'AdminSettingsDepartmentsAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'departments/:id',
          props: true,
          component: AdminSettingsDepartmentsAddOrEdit,
          name: 'AdminSettingsDepartmentsEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'department-rates',
          props: true,
          component: AdminSettingsDepartmentsRates,
          name: 'AdminSettingsDepartmentsRates',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'department-rates/add',
          props: true,
          component: AdminSettingsDepartmentsRatesAddOrEdit,
          name: 'AdminSettingsDepartmentsRatesAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'department-rates/:id',
          props: true,
          component: AdminSettingsDepartmentsRatesAddOrEdit,
          name: 'AdminSettingsDepartmentsRatesEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'payment-methods',
          props: true,
          component: AdminSettingsPaymentMethods,
          name: 'AdminSettingsPaymentMethods',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'payment-methods/add',
          props: true,
          component: AdminSettingsPaymentMethodsAddOrEdit,
          name: 'AdminSettingsPaymentMethodAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'payment-methods/:id',
          props: true,
          component: AdminSettingsPaymentMethodsAddOrEdit,
          name: 'AdminSettingsPaymentMethodEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'website-addresses',
          props: true,
          component: AdminSettingsWebSiteAddresses,
          name: 'AdminSettingsWebSiteAddresses',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'website-addresses/add',
          props: true,
          component: AdminSettingsWebSiteAddressesAddOrEdit,
          name: 'AdminSettingsWebSiteAddressAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'duties',
          props: true,
          component: AdminSettingsDuties,
          name: 'AdminSettingsDuties',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'duties/add',
          props: true,
          component: AdminSettingsDutiesAddOrEdit,
          name: 'AdminSettingsDutiesAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'duties/:id',
          props: true,
          component: AdminSettingsDutiesAddOrEdit,
          name: 'AdminSettingsDutiesEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'delivery-prices',
          props: true,
          component: AdminSettingsManageDeliveryPricesEdit,
          name: 'AdminSettingsManageDeliveryPricesEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'custom-charges',
          props: true,
          component: AdminSettingsCustomCharges,
          name: 'AdminSettingsCustomCharges',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'custom-charges/add',
          props: true,
          component: AdminSettingsCustomChargesAddOrEdit,
          name: 'AdminSettingsCustomChargesAdd',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'custom-charges/:id',
          props: true,
          component: AdminSettingsCustomChargesAddOrEdit,
          name: 'AdminSettingsCustomChargesEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'website-addresses/:id',
          props: true,
          component: AdminSettingsWebSiteAddressesAddOrEdit,
          name: 'AdminSettingsWebSiteAddressEdit',
          meta: {
            requiresAuth: true,
            isAdmin: true,
            props: true,
          },
        },
        {
          path: 'messenger-translations',
          props: true,
          component: AdminSettingsMessengerTranslations,
          name: 'MessengerTranslations',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'delivery-options',
          props: true,
          component: AdminSettingsDeliveryOptions,
          name: 'DeliveryOptions',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
        {
          path: 'exchange-rates',
          props: true,
          component: AdminSettingsExchangeRates,
          name: 'ExchangeRates',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
        },
      ],
    },
  ]
})

router.beforeEach(AuthGuard)
export default router

